import { createFileRoute } from '@tanstack/react-router';
import { ensureOBSPresence } from '../../../../../utils/ensureOBSPresence';
import { PendingOBSApi } from '../../../../../components/PendingOBSApi';

export const Route = createFileRoute('/_authenticated/canvases/$canvasId/new/scene/')({
  component: () => <div></div>,
  pendingComponent: PendingOBSApi,
  loader: async () => await ensureOBSPresence(),
});
